import Link from 'next/link';
import { useTranslations } from 'next-intl';

import ArrowIcon from '@/fo/icons/base/icons/arrow.svg';
import InfoIcon from '@/fo/icons/base/icons/info.svg';
import MarkerIcon from '@/fo/icons/base/icons/pin.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitTooltipBase } from '@/fo/ui/kit/tooltip/base';
import { utilEventAuthModal } from '@/fo/util/event-auth-modal';

import { styles } from './Bonuses.styles';

export interface BonusesProps {
  className?: string;
  bonuses: number;
  bonusesMax: number;
  isAuthorized?: boolean;
  showLogin?: boolean;
  size?: 'xs' | 's';
}

export function Bonuses({
  className,
  bonuses,
  bonusesMax,
  isAuthorized,
  showLogin = true,
  size = 's'
}: BonusesProps) {
  const slots = styles({});
  const t = useTranslations();

  const bonusesMessage = `${bonuses} ${t('points')}`;
  const maxBonusesMessage = `${t('up to')} ${bonusesMax} ${t('points')}`;
  const message =
    isAuthorized && bonuses > 0 ? bonusesMessage : maxBonusesMessage;

  return (
    <div className={slots.base({ className })}>
      <MarkerIcon className={slots.markerIcon()} />
      <span className={slots.text({ size })}>
        {isAuthorized ? message : <span>{message}</span>}
        {!isAuthorized && showLogin && (
          <>
            {'. '}
            <UiKitButtonBase
              color="white"
              onClick={() => utilEventAuthModal.open('loyalty')}
              className={slots.authButton()}
            >
              {t('Login')}
            </UiKitButtonBase>
          </>
        )}
      </span>
      <UiKitTooltipBase
        side="bottom"
        content={
          <div className={slots.info()}>
            <p className={slots.infoTitle()}>{t('The Privilege Program')}</p>
            <p className={slots.infoText()}>
              {t(
                'Join the Privilege Program and receive pleasant bonuses and gifts with every purchase'
              )}
              .
            </p>

            <Link
              href="/loyalty"
              className={slots.infoLink()}
            >
              {t('More')}
              <ArrowIcon />
            </Link>
          </div>
        }
      >
        <InfoIcon className={slots.infoIcon()} />
      </UiKitTooltipBase>
    </div>
  );
}
